import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';

import * as Device from 'expo-device';

import Button from './Button';
import PFPPreviewForRenderingToImage from './PFPPreviewForRenderingToImage';
import SelectedParts from '../types/SelectedParts';
import html2canvas from 'html2canvas';
import isSafari from '../utils/isSafari';
import { usePFPGeneratorContext } from '../contexts/PFPGeneratorContext';

type Props = {
  selectedParts: SelectedParts;
};

export default ({ selectedParts }: Props) => {
  const pfpPreviewRef = useRef();

  const { setMobileDevicePFPImageDataUri } = usePFPGeneratorContext();

  const handleDownloadButtonPress = async () => {
    const canvas = await html2canvas(pfpPreviewRef.current, {
      scale: isSafari() ? 0.5 : 1,
    });
    const dataUrl = canvas.toDataURL('image/jpeg', 1.0);

    const deviceType = await Device.getDeviceTypeAsync();

    if (deviceType === Device.DeviceType.DESKTOP) {
      var link = document.createElement('a');
      link.download = 'MyPFP.jpeg';
      link.href = dataUrl;
      link.click();
    } else {
      setMobileDevicePFPImageDataUri(dataUrl);
    }
  };

  return (
    <View style={styles.container}>
      <Button title="Download image" onPress={handleDownloadButtonPress} />
      <PFPPreviewForRenderingToImage
        ref={pfpPreviewRef}
        selectedParts={selectedParts}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
});
